import request from 'utils/request';

export async function login(data) {
  return await request('/api/user/login', {
    method: 'POST',
    data,
  })
}

export async function mblogin(data) {
  return await request('/api/user/mobile_login', {
    method: 'POST',
    data,
  })
}

export async function passwordUpdate(data) {
  return await request('/api/user/password/change', {
    method: 'PUT',
    data,
  })
}

export async function logout() {
  return request('/api/auth/logout', {
    method: 'GET',
  })
}

export function relogin() {
  return request('/api/user/info')
}

export function send(data) {
  return request('/api/user/send_code', {method:'POST', data})
}